import { sortOrdersByDeliveryGroup } from "../order-schedule/functions";
import { getYearMonthDate } from '../calendar';

export function handleSchedulesResult(data) {
  const orders = [];
  data.forEach(item => {

    let found = orders.find(order =>
			order['customerId-serviceTime'] === `${item.customerId}-${item.serviceTime}`);

    if (!found) {
      found = {};
      found['customerId-serviceTime'] = `${item.customerId}-${item.serviceTime}`;
      found['customerId'] = item.customerId;
      found['customerName'] = item.customer.name;
      found['serviceTime'] = item.serviceTime;
      found['deliveryGroup'] = item.customer.deliveryGroup?.desc ?? null;
      found['menu'] = [];
      orders.push(found);
    }

    found.menu.push({
			id: item.id,
			published: item.published,
			lock: false,
			date: item.date,
			supplierId: item.supplier?.id ?? null,
			supplierName: item.supplier?.name ?? null, 
			menuType: item.menuType,
			menuId: item.menuId,
			menuName: item.menu?.name ?? null, 
			menuCategory: item.menu?.menuCategory ?? [],
			serviceType: item.supplier?.serviceType ?? [],
			subMenu: item.subMenu ?? [],
			pickupTime: item.pickupTime,
			orderQty: item.orderQty ?? 0,
			memo: item.memo ?? null
		});
  })

  sortOrdersByDeliveryGroup(orders);

  return orders;
}